import { render, staticRenderFns } from "./CognitoMfaVerify.vue?vue&type=template&id=65e021ae&scoped=true"
import script from "./CognitoMfaVerify.vue?vue&type=script&lang=ts"
export * from "./CognitoMfaVerify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e021ae",
  null
  
)

export default component.exports